<template>
  <div class="login-container">
    <div class="logo-container">
      <DvLogoComponent />
    </div>
    <div class="login-form-container">
      <div class="auth-form">
        <h1>Подтверждение регистрации</h1>
        <div v-if="status === 'loading'" class="text">
          Подтверждаем вашу регистрацию...
        </div>
        <div v-if="status === 'error'" class="bad-msg">
          {{ errorMessage }}
        </div>
        <div class="actions" v-if="status === 'error'">
          <Button
            label="Перейти к регистрации"
            class="form-button"
            @click="router.push({ name: 'signup' })"
          />
        </div>
        <div class="fl-senter m-t-5" v-if="status === 'loading'">
          <ProgressSpinner
            aria-label="Loading"
            style="width: 30px; height: 30px"
            strokeWidth="2"
            fill="var(--surface-ground)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { rootGetters } from "@/main";

import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";

import DvLogoComponent from "@/shared/auth/DvLogoComponent.vue";

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();
const status = ref<"loading" | "error">("loading");
const errorMessage = ref("");

const confirmRegistration = async () => {
  const nonce = route.query.nonce?.toString();
  if (!nonce) {
    status.value = "error";
    errorMessage.value = "Некорректная ссылка подтверждения.";
    return;
  }

  await authStore
    .registerConfirm(nonce)
    .then(async () => {
      await authStore.getUserInfo();
      await router.push({ path: "/" });
    })
    .catch((err) => {
      status.value = "error";
      if (err.response && err.response.status === 400) {
        errorMessage.value = "Ссылка устарела или уже использована.";
      } else {
        rootGetters.toast.show(
          "error",
          "Произошла ошибка",
          "Обратитесь к администратору или проверьте соединение с интернетом."
        );
        errorMessage.value = "Не удалось подтвердить регистрацию.";
      }
    });
};

onMounted(() => {
  confirmRegistration();
});
</script>

<style scoped lang="scss">
.login-container {
  display: flex;
  height: 100vh;
  padding: 20px;
}

.logo-container {
  flex: 1;
  margin-right: 20px;
}

.login-form-container {
  flex: 1;
  background-color: white;
  border-radius: 20px;
  position: relative;
}

.auth-form {
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  width: 344px;
}

h1 {
  font-size: 2em;
  font-weight: 600;
  line-height: 142%;
  margin-bottom: 8px;
}

.text {
  margin-top: 8px;
  margin-bottom: 7px;
  font-size: 1em;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.bad-msg {
  font-size: 0.9em;
  font-weight: 400;
  line-height: 130%;
  margin-top: 10px;
  color: red;
}

.actions {
  margin-top: 12px;
}

.form-button {
  width: 100%;
}

.m-t-5 {
  margin-top: 5px;
}

.fl-senter {
  display: flex;
  justify-content: center;
}
</style>
